import { useEffect, useState } from "react";
import { Loader2, Repeat } from "lucide-react";
import { adminApi } from "@/lib/api";
import { StatusBadge, fmtMoney, fmtDateTime } from "@/components/status";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function StoreOrdersDialog({ store, onClose }) {
  const [orders, setOrders] = useState(null);
  const [tab, setTab] = useState("orders");
  useEffect(() => {
    if (!store) return;
    setOrders(null);
    adminApi.allOrders("all").then((all) => setOrders(all.filter((o) => o.store_code === store.store_code).sort((a, b) => (b.created_at || "").localeCompare(a.created_at || "")))).catch(() => setOrders([]));
  }, [store]);
  if (!store) return null;
  const standing = (orders || []).filter((o) => o.is_standing);
  const regular = (orders || []).filter((o) => !o.is_standing);
  const list = tab === "orders" ? regular : standing;
  return (
    <Dialog open={!!store} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="store-orders-dialog">
        <DialogHeader><DialogTitle><span className="font-mono">{store.store_code}</span> · {store.store_name}</DialogTitle></DialogHeader>
        <div className="flex rounded-md border border-slate-200 p-0.5 text-sm">
          {[["orders", `Orders (${regular.length})`], ["standing", `Standing orders (${standing.length})`]].map(([k, l]) => (
            <button key={k} data-testid={`store-orders-tab-${k}`} onClick={() => setTab(k)} className={`flex-1 rounded px-3 py-1.5 ${tab === k ? "bg-[#28282E] text-white" : "text-[#28282E]"}`}>{l}</button>
          ))}
        </div>
        {!orders ? <div className="grid place-items-center py-10"><Loader2 className="h-6 w-6 animate-spin text-[#28282E]/50" /></div> : (
          <div className="max-h-[55vh] space-y-2 overflow-y-auto pr-1">
            {list.map((o) => (
              <div key={o.id} data-testid={`store-order-${o.id}`} className="rounded-xl border border-slate-200 p-3 text-xs">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div className="flex items-center gap-2 font-semibold text-[#28282E]">{o.is_standing && <Repeat className="h-3.5 w-3.5 text-[#D46117]" />}{fmtDateTime(o.created_at)}{o.delivery_estimate ? <span className="font-normal text-[#28282E]/60">· deliver {o.delivery_estimate}</span> : null}</div>
                  <div className="flex items-center gap-2"><StatusBadge status={o.status} /><span className="font-bold text-[#28282E]">{fmtMoney(o.total)}</span></div>
                </div>
                <div className="mt-1.5 text-[#28282E]/75">{(o.items || []).map((it) => `${it.qty || it.quantity || 1}× ${it.name}`).join(" · ")}</div>
                {o.placed_by_name && <div className="mt-1 text-[10px] text-[#28282E]/50">Placed by {o.placed_by_name}</div>}
              </div>
            ))}
            {list.length === 0 && <p className="py-8 text-center text-xs text-[#28282E]/50">{tab === "orders" ? "No orders from this store yet." : "No standing orders for this store."}</p>}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
